/**
 * Created by christophe.gaon on 11/01/2017.
 */
import debounce from 'lodash/debounce';

/**
 * @module Component/Background
 * @desc the Background tag implement  a responsive background image on a div element
 */

export default {
  /**
   * @member {type} name tag name of the component
   * @readonly
   */
  name: 'background',
  props: {
    /**
     * @member {string} backgroundDesktop
     * @desc path of the image for background Image in other screen
     */
    backgroundDesktop: {
      type: String,
      required: true,
    },
    /**
     * @member {string} backgroundMobile
     * @desc path of the image for background Image in mobile screen
     */
    backgroundMobile: {
      type: String,
      required: true,
    },
  },
  methods: {
    /**
     * @function UpdateImg
     * @desc Update the image according to the window resized
     * @param target window resized
     */
    updateImg: function (target) {
      if (target.innerWidth > this.screenSizes.SCREEN_XS) {
        this.styleObject.backgroundImage = `url(${this.backgroundDesktop})`;
      } else {
        this.styleObject.backgroundImage = `url(${this.backgroundMobile})`;
      }
    },
  },
  /**
   * @function created
   * @desc on mounting , listen to resize the window
   */
  created: function () {
    this.updateImg(window);
    window.onresize = debounce((event) => {
      this.updateImg(event.target);
    }, 150);
  },
  /**
   * @function data
   * @desc init the style when the component mount
   */
  data: function () {
    return {
      styleObject: {
        backgroundImage: '',
      },
    };
  },
};
